/**
 * @file: useAmendQuotationForm.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { useQuotationNavigation } from '@euler/app/flows/task/pages/quotation/functions/useQuotationNavigation';
import { useAppLoading } from '@euler/components/loading/Provider';
import { useConfirm } from '@euler/functions/ux/useConfirm';
import { safeMarkDevFlag } from '@euler/utils';
import { useCallback } from 'react';

const kSimulateAmend = safeMarkDevFlag(false);

export const useAmendQuotationForm = () => {
  const confirm = useConfirm();
  const loading = useAppLoading();
  const navigation = useQuotationNavigation();
  const { taskManager } = useTaskContext();

  return useCallback(async () => {
    if (
      !(await confirm({
        title: '是否确认修改当前维修报价单？',
      }))
    ) {
      return;
    }

    await loading.showWithAction(async () => {
      if (kSimulateAmend) {
        await sleep(1000);
      } else {
        await taskManager.quotationManager.requestAmend();
      }
      navigation.popToTop();
      setTimeout(() => {
        navigation.replace('_main', {
          animationTypeForReplace: 'push',
          animationEnabled: false,
        });
      }, 300);
    });
  }, [confirm, loading, navigation, taskManager.quotationManager]);
};
